import axios from 'axios';

axios.defaults.withCredentials = true;

class RestClient {
    constructor(endpoint, context) {
        this.context = context;

        this.HTTP = axios.create({
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });

        this.BASE_URL = 'https://liquidity-dev.webgurus.biz';
        this.HTTP.interceptors.request.use(
            (config) => {
                this.context.commit('setLoadingState', true);
                return config;
            },
            (error) => {
                this.context.commit('setLoadingState', false);
                return Promise.reject(error);
            }
        );
        this.HTTP.interceptors.response.use(
            (response) => {
                this.context.commit('setLoadingState', false);
                if (response.status == 201) {
                    this.context.dispatch('showNotification', { message: 'Uploaded to sheets!', color: 'lime', position: 'top' });
                }
                return response;
            },
            (error) => {
                this.context.commit('setLoadingState', false);
                this.context.dispatch('showNotification', { message: 'Something went wrong, all data saved locally', color: 'red', position: 'top' });

                if (error.response) {
                    if (error.response.status == 401) {
                        this.context.dispatch('showNotification', { message: 'Unauthorized!', color: 'red' });
                    } else if (error.response.status == 422) {
                        this.context.dispatch('showNotification', { message: 'Unprocessable Entity!', color: 'red' });
                    } else if (error.response.status == 500) {
                        this.context.dispatch('showNotification', { message: 'Something went wrong!', color: 'red' });
                    }
                }

                return Promise.reject(error);
            }
        );

        this.endpoint = endpoint;
    }

    get(id) {
        return this.HTTP.get(`${this.BASE_URL}/sanctum/csrf-cookie`).then(() =>
            this.HTTP.get(`${this.BASE_URL}${this.endpoint}${id}`)
                .then((res) => this.httpCallSuccess(res, id))
                .catch((rej) => this.httpCallError(rej, id))
        );
    }
    post(id, data) {
        return this.HTTP.get(`${this.BASE_URL}/sanctum/csrf-cookie`).then((res) => {
            return this.HTTP.post(`${this.BASE_URL}${this.endpoint}${id}`, data)
                .then((res) => {
                    return Promise.resolve(this.httpCallSuccess(res, id));
                })
                .catch((rej) => {
                    return Promise.reject(this.httpCallError(rej, id));
                });
        });
    }
    postFormData(URL, payload) {
        return this.HTTP.post(`${this.BASE_URL}${URL}`, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then((res) => this.httpCallSuccess(res));
    }
    httpCallSuccess(res) {
        return res;
    }
    httpCallError(error) {
        return error;
    }
}

export { RestClient };
